'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Record;

var _immutable = require('immutable');

var _messageTypes = require('../../pubnub-message/constants/messageTypes');

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

exports.default = (0, _immutable.Record)((_Record = {}, _defineProperty(_Record, _messageTypes.MESSAGE_TYPE_ID, _messageTypes.CONNECTED_ACCOUNT_STATUS_UPDATE), _defineProperty(_Record, 'email', null), _defineProperty(_Record, 'connected', null), _defineProperty(_Record, 'connectedAccountId', null), _Record), 'ConnectedAccountStatusUpdateMetadata');
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/records/PubNubMessageMetadata/ConnectedAccountStatusUpdateMetadata.js
// module id = 720
// module chunks = 2 3